import {
  MEDICO_POR_MATRICULA,
  MEDICO_POR_MATRICULA_FAIL,
  MEDICO_POR_MATRICULA_SUCCESS,
  
} from "../ActionTypes";


const medicoPorMatricula = (state, { payload, type }) => {
  switch (type) {
    case MEDICO_POR_MATRICULA:
      return {
        ...state,
        medicoPorMatricula: {
          ...state.medicoPorMatricula,
          loading: true,
          error: false,
          data: false,
        },
      };
    case MEDICO_POR_MATRICULA_SUCCESS:
      return {
        ...state,
        medicoPorMatricula: {
          ...state.medicoPorMatricula,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case MEDICO_POR_MATRICULA_FAIL:
      return {
        ...state,
        medicoPorMatricula: {
          ...state.medicoPorMatricula,
          loading: false,
          error: payload,
          data: false,
        },
      };


    default:
      return state;
  }
};

export default medicoPorMatricula;
